import { Link } from 'react-router-dom';
import DoughnutChart from '../../../components/charts/DonughtChart';
import List from '../list';
import JobList from '../JobList';
import EmployeeOfMonth from '../EmployeeOfMonth';

const EmployeeSidebar = ({
  dashboards,
  employees,
  Today,
  TodayDOJ,
  Upcoming,
  UpcomingDOJ,
}) => {
  return (
    <div className='employee-sidebar'>
      {/* Activity Chart */}
      <div className='sidebar-card'>
        <div className='sidebar-card-header'>
          <h6 className='sidebar-title'>
            <i className='fas fa-chart-doughnut me-2'></i>
            Activity Overview
          </h6>
        </div>
        <div className='sidebar-card-body'>
          <DoughnutChart
            graph_data={dashboards && dashboards.activities_status_array}
          />
        </div>
      </div>

      {/* Activity Stats */}
      <div className='row mb-3'>
        <div className='col-6'>
          <div className='mini-stat-card'>
            <div className='mini-stat-icon'>
              <i className='fas fa-tasks'></i>
            </div>
            <div className='mini-stat-content'>
              <div className='mini-stat-title'>Total Activities</div>
              <div className='mini-stat-value'>
                <Link to='/activitys'>
                  {dashboards && dashboards.total_activities
                    ? dashboards.total_activities
                    : 0}
                </Link>
              </div>
            </div>
          </div>
        </div>

        {dashboards &&
          dashboards.activities_status_array &&
          dashboards.activities_status_array.slice(0, 3).map((item, index) => (
            <div key={index} className='col-6 mb-2'>
              <div className='mini-stat-card'>
                <div className='mini-stat-icon'>
                  <i className='fas fa-circle'></i>
                </div>
                <div className='mini-stat-content'>
                  <div className='mini-stat-title'>
                    {item.status ? item.status : 'Other'}
                  </div>
                  <div className='mini-stat-value'>
                    <Link to={`/activitys?exact[activity_status]=${item._id}`}>
                      {item.count}
                    </Link>
                  </div>
                </div>
              </div>
            </div>
          ))}
      </div>

      {/* Today's Birthdays */}
      <div className='sidebar-card'>
        <div className='sidebar-card-header'>
          <h6 className='sidebar-title'>
            <i className='fas fa-birthday-cake me-2'></i>
            Today's Birthday 🥳🎉
          </h6>
        </div>
        <div className='sidebar-card-body'>
          <List info={Today(employees)} />
        </div>
      </div>

      {/* Upcoming Birthdays */}
      <div className='sidebar-card'>
        <div className='sidebar-card-header'>
          <h6 className='sidebar-title'>
            <i className='fas fa-calendar-alt me-2'></i>
            Upcoming Birthdays
          </h6>
        </div>
        <div className='sidebar-card-body'>
          <List info={Upcoming(employees, 3)} Upcoming />
        </div>
      </div>

      {/* Today's Job Anniversary */}
      <div className='sidebar-card'>
        <div className='sidebar-card-header'>
          <h6 className='sidebar-title'>
            <i className='fas fa-briefcase me-2'></i>
            Today's Job Anniversary 🥳🎉
          </h6>
        </div>
        <div className='sidebar-card-body'>
          <JobList info={TodayDOJ(employees)} />
        </div>
      </div>

      {/* Upcoming Job Anniversary */}
      <div className='sidebar-card'>
        <div className='sidebar-card-header'>
          <h6 className='sidebar-title'>
            <i className='fas fa-calendar-check me-2'></i>
            Upcoming Job Anniversary
          </h6>
        </div>
        <div className='sidebar-card-body'>
          <JobList info={UpcomingDOJ(employees, 3)} Upcoming />
        </div>
      </div>

      {/* Holiday List */}
      {/* <div className="sidebar-card">
        <div className="sidebar-card-header">
          <h6 className="sidebar-title">
            <i className="fas fa-calendar me-2"></i>
            Holidays List 2024
          </h6>
        </div>
        <div className="sidebar-card-body p-0">
          <div className="table-responsive">
            <table className="table table-sm holiday-table mb-0">
              <thead>
                <tr>
                  <th>#</th>
                  <th>Holiday</th>
                  <th>Date</th>
                  <th>Day</th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td>1</td>
                  <td>Republic Day</td>
                  <td>26-01-2024</td>
                  <td>Friday</td>
                </tr>
                <tr>
                  <td>2</td>
                  <td>Holi</td>
                  <td>25-03-2024</td>
                  <td>Monday</td>
                </tr>
                <tr>
                  <td>3</td>
                  <td>Id-ul-Fitr</td>
                  <td>11-04-2024</td>
                  <td>Thursday</td>
                </tr>
                <tr>
                  <td>4</td>
                  <td>Ram Navami</td>
                  <td>17-04-2024</td>
                  <td>Wednesday</td>
                </tr>
                <tr>
                  <td>5</td>
                  <td>Id-ul-Zuha</td>
                  <td>17-06-2024</td>
                  <td>Monday</td>
                </tr>
                <tr>
                  <td>6</td>
                  <td>Muharram</td>
                  <td>17-07-2024</td>
                  <td>Wednesday</td>
                </tr>
                <tr>
                  <td>7</td>
                  <td>Independence Day</td>
                  <td>15-08-2024</td>
                  <td>Thursday</td>
                </tr>
                <tr>
                  <td>8</td>
                  <td>Rakha Bandhan</td>
                  <td>19-08-2024</td>
                  <td>Monday</td>
                </tr>
                <tr>
                  <td>9</td>
                  <td>Janmastmi</td>
                  <td>26-08-2024</td>
                  <td>Monday</td>
                </tr>
                <tr>
                  <td>10</td>
                  <td>Gandhi's Birthday</td>
                  <td>02-10-2024</td>
                  <td>Wednesday</td>
                </tr>
                <tr>
                  <td>11</td>
                  <td>Dussehra</td>
                  <td>12-10-2024</td>
                  <td>Saturday</td>
                </tr>
                <tr>
                  <td>12</td>
                  <td>Diwali</td>
                  <td>31-10-2024</td>
                  <td>Thursday</td>
                </tr>
                <tr>
                  <td>13</td>
                  <td>Guru Nanak's Birthday</td>
                  <td>15-Nov-2024</td>
                  <td>Friday</td>
                </tr>
                <tr>
                  <td>14</td>
                  <td>Christmas Day</td>
                  <td>25-12-2024</td>
                  <td>Wednesday</td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div> */}
      {/* <div className='sidebar-card'>
        <div className='sidebar-card-header'>
          <h6 className='sidebar-title'>
            <i className='fas fa-calendar me-2'></i>
            Holidays List 2025
          </h6>
        </div>
        <div className='sidebar-card-body p-0'>
          <div className='table-responsive'>
            <table className='table table-sm holiday-table mb-0'>
              <thead>
                <tr>
                  <th>#</th>
                  <th>Holiday</th>
                  <th>Date</th>
                  <th>Day</th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td>1</td>
                  <td>Republic Day</td>
                  <td>26-01-2025</td>
                  <td>Sunday</td>
                </tr>
                <tr>
                  <td>2</td>
                  <td>Holi</td>
                  <td>14-03-2025</td>
                  <td>Friday</td>
                </tr>
                <tr>
                  <td>3</td>
                  <td>Id-ul-Fitr</td>
                  <td>31-03-2025</td>
                  <td>Monday</td>
                </tr>
                <tr>
                  <td>4</td>
                  <td>Ram Navami</td>
                  <td>06-04-2025</td>
                  <td>Sunday</td>
                </tr>
                <tr>
                  <td>5</td>
                  <td>Id-ul-Zuha</td>
                  <td>07-06-2025</td>
                  <td>Saturday</td>
                </tr>
                <tr>
                  <td>6</td>
                  <td>Muharram</td>
                  <td>06-07-2025</td>
                  <td>Sunday</td>
                </tr>
                <tr>
                  <td>7</td>
                  <td>Raksha Bandhan</td>
                  <td>09-08-2025</td>
                  <td>Saturday</td>
                </tr>
                <tr>
                  <td>8</td>
                  <td>Independence Day</td>
                  <td>15-08-2025</td>
                  <td>Friday</td>
                </tr>
                <tr>
                  <td>9</td>
                  <td>Janmashtami</td>
                  <td>16-08-2025</td>
                  <td>Saturday</td>
                </tr>
                <tr>
                  <td>10</td>
                  <td>Gandhi's Birthday</td>
                  <td>02-10-2025</td>
                  <td>Thursday</td>
                </tr>
                <tr>
                  <td>11</td>
                  <td>Dussehra</td>
                  <td>02-10-2025</td>
                  <td>Thursday</td>
                </tr>
                <tr>
                  <td>12</td>
                  <td>Diwali</td>
                  <td>20-10-2025</td>
                  <td>Monday</td>
                </tr>
                <tr>
                  <td>13</td>
                  <td>Guru Nanak's Birthday</td>
                  <td>05-11-2025</td>
                  <td>Wednesday</td>
                </tr>
                <tr>
                  <td>14</td>
                  <td>Christmas Day</td>
                  <td>25-12-2025</td>
                  <td>Thursday</td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div> */}

      {/* Holiday List 2025 - Removed, now using PDF link in main dashboard */}

      {/* Employee of the Month */}
      {/* <div className='sidebar-card'>
        <EmployeeOfMonth
          image={'/images/employee-of-month/manmendar.jpeg'}
          name={'Manmender'}
          short_desc={
            'Congratulations on delivering the most amazing work Luhaif Digitech 🎉'
          }
        />
      </div> */}

      {/* Company Announcements */}
      {/* <div className='sidebar-card'>
        <div className='announcement-card'>
          <img
            src='/images/eid_mubarak.jpg'
            alt='Eid Mubarak'
            className='announcement-image'
          />
          <div className='announcement-content'>
            <h6 className='announcement-title'>Eid Mubarak 🌙</h6>
            <p className='announcement-text'>
              Wish you a very Happy Eid Mubarak!!
              <br />- Luhaif Digitech
            </p>
          </div>
        </div>
      </div> */}

      {/* <div className='sidebar-card'>
        <div className='announcement-card'>
          <img
            src='/images/ld-winner.jpeg'
            alt='Winner'
            className='announcement-image'
          />
          <div className='announcement-content'>
            <h6 className='announcement-title'>
              Congratulations on your well-deserved victory! You're an
              inspiration! 🎉
            </h6>
            <p className='announcement-text'>- Luhaif Digitech</p>
          </div>
        </div>
      </div> */}

      <style jsx>{`
        .employee-sidebar {
          display: flex;
          flex-direction: column;
          gap: 16px;
        }

        .sidebar-card {
          background: #fff;
          border: 1px solid #e3e9f3;
          border-radius: 8px;
          box-shadow: rgb(227 233 243) 0px 4px 22px;
          overflow: hidden;
        }

        .sidebar-card-header {
          background: linear-gradient(135deg, #f8f9fa 0%, #e9ecef 100%);
          border-bottom: 1px solid #e3e9f3;
          padding: 10px 12px;
        }

        .sidebar-title {
          margin: 0;
          font-size: 12px;
          font-weight: 600;
          color: #495057;
          display: flex;
          align-items: center;
        }

        .sidebar-card-body {
          padding: 12px;
        }

        .mini-stat-card {
          background: #fff;
          border: 1px solid #e3e9f3;
          border-radius: 6px;
          padding: 10px;
          display: flex;
          align-items: center;
          gap: 8px;
          box-shadow: rgb(227 233 243) 0px 2px 8px;
          transition: transform 0.2s ease;
        }

        .mini-stat-card:hover {
          transform: translateY(-1px);
        }

        .mini-stat-icon {
          width: 28px;
          height: 28px;
          border-radius: 6px;
          background: #007bff;
          color: #fff;
          display: flex;
          align-items: center;
          justify-content: center;
          font-size: 12px;
        }

        .mini-stat-content {
          flex: 1;
          min-width: 0;
        }

        .mini-stat-title {
          font-size: 10px;
          color: #6c757d;
          font-weight: 500;
          margin-bottom: 2px;
          line-height: 1.2;
        }

        .mini-stat-value {
          font-size: 14px;
          font-weight: 700;
          color: #495057;
          line-height: 1;
        }

        .mini-stat-value a {
          color: inherit;
          text-decoration: none;
        }

        .mini-stat-value a:hover {
          color: #007bff;
        }

        .holiday-table {
          font-size: 12px;
        }

        .holiday-table thead th {
          background: #f8f9fa;
          border-bottom: 1px solid #e3e9f3;
          color: #495057;
          font-weight: 600;
          padding: 8px 6px;
        }

        .holiday-table tbody td {
          padding: 6px;
          border-bottom: 1px solid #f1f3f4;
          color: #6c757d;
        }

        .holiday-table tbody tr:hover {
          background-color: #f8f9fa;
        }

        .announcement-card {
          text-align: center;
        }

        .announcement-image {
          width: 100%;
          height: 150px;
          object-fit: cover;
          border-radius: 6px;
          margin-bottom: 10px;
        }

        .announcement-content {
          padding: 0 8px;
        }

        .announcement-title {
          font-size: 12px;
          font-weight: 600;
          color: #495057;
          margin-bottom: 6px;
          line-height: 1.3;
        }

        .announcement-text {
          font-size: 11px;
          color: #6c757d;
          margin: 0;
          line-height: 1.4;
        }

        @media (max-width: 768px) {
          .employee-sidebar {
            gap: 12px;
          }

          .sidebar-card-body {
            padding: 10px;
          }

          .mini-stat-card {
            padding: 8px;
          }
        }
      `}</style>
    </div>
  );
};

export default EmployeeSidebar;
